import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { enrollmentService } from '@/services/enrollment-service';
import type { EnrollmentCredentialUse } from '@/types/core/enrollment';
import type { UUID } from '@/utils/uuid';

import { enrollmentQueryKeys } from './query-keys';

/**
 * List every agent enrolled through one credential — the blast-radius view.
 */
export function useEnrollmentCredentialUses(
  tenantId: UUID | undefined,
  credentialId: UUID | undefined
): UseQueryResult<EnrollmentCredentialUse[], Error> {
  return useQuery<EnrollmentCredentialUse[], Error>({
    queryKey: enrollmentQueryKeys.uses(tenantId, credentialId),
    queryFn: () =>
      enrollmentService.listCredentialUses(tenantId!, credentialId!),
    enabled: !!tenantId && !!credentialId,
  });
}
